<ngx-spinner bdColor="#081636"></ngx-spinner>
<router-outlet></router-outlet>
